import { IssueDispositionTypes } from '../../../cimsPage/instances/issues'
import { DispositionTypes } from '../../common'

const { Create, Edit, RemoveRestore, View } = DispositionTypes({
  create: '093095e9-81e5-42d9-91ad-769ab183507c',
  edit: 'b603b45d-5e4f-487e-9d7c-787f73adfd34',
  view: 'b2135790-68ce-4726-82e5-1113abdde43a',
  removeRestore: 'cbe6d786-5f54-4b3f-8ca7-7ef815dc4fd8',
  page: IssueDispositionTypes,
})

export const CreateIssueDispositionType = Create
export const EditIssueDispositionType = Edit
export const RemoveRestoreIssueDispositionType = RemoveRestore
export const ViewIssueDispositionType = View

export type IssueDispositionTypePermission =
  | typeof CreateIssueDispositionType
  | typeof EditIssueDispositionType
  | typeof RemoveRestoreIssueDispositionType
  | typeof ViewIssueDispositionType
